;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:localcoin":true});}catch(e){}}();import { LOCAL_STORAGE_CHANGE_EVENT_NAME } from '@/consts/localStorage';

import { dispatchGlobalEvent } from './browser';

export const getLocalStorageValue = (key: string): string | null => {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
};

export const setLocalStorageValue = <T>(key: string, val: T): boolean => {
  try {
    const stringifiedValue = JSON.stringify(val);

    localStorage.setItem(key, stringifiedValue);
    dispatchGlobalEvent(LOCAL_STORAGE_CHANGE_EVENT_NAME);

    return true;
  } catch {
    return false;
  }
};

export const removeLocalStorageValue = (key: string): void => {
  localStorage.removeItem(key);
  dispatchGlobalEvent(LOCAL_STORAGE_CHANGE_EVENT_NAME);
};
